"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Dialog2 = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _NoteAddRounded2 = _interopRequireDefault(require("@material-ui/icons/NoteAddRounded"));

var _Close2 = _interopRequireDefault(require("@material-ui/icons/Close"));

var _InputBase2 = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _InputAdornment2 = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _Search2 = _interopRequireDefault(require("@material-ui/icons/Search"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Link2 = _interopRequireDefault(require("@material-ui/icons/Link"));

var _Attachment2 = _interopRequireDefault(require("@material-ui/icons/Attachment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DialogAttachment = function DialogAttachment(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onUpload = _ref.onUpload;

  var _React$useState = React.useState(""),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      url = _React$useState2[0],
      setUrl = _React$useState2[1];

  var _React$useState3 = React.useState("My Device"),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      tab = _React$useState4[0],
      setTab = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      viewSelect = _React$useState6[0],
      setViewSelect = _React$useState6[1];

  var _React$useState7 = React.useState(""),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      findFile = _React$useState8[0],
      setFindFile = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      selectedFiles = _React$useState10[0],
      setSelectedFiles = _React$useState10[1];

  var listUploads = [{
    name: "My Device",
    icon: /*#__PURE__*/React.createElement(_Attachment2["default"], null)
  }, {
    name: "Link (URL)",
    icon: /*#__PURE__*/React.createElement(_Link2["default"], null)
  }];

  var handleChangeFile = function handleChangeFile(event) {
    var file = event.target.files[0];
    setSelectedFiles([].concat(_toConsumableArray(selectedFiles), [{
      file: file,
      url: URL.createObjectURL(file),
      fileName: file.name,
      from: "My Device"
    }]));
  };

  var filterFiles = !findFile ? selectedFiles : selectedFiles.filter(function (item) {
    return item.fileName.toLowerCase().includes(findFile.toLocaleLowerCase());
  });
  return /*#__PURE__*/React.createElement(_Dialog2["default"], {
    open: open,
    onClose: onClose,
    maxWidth: "lg"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: 800,
      height: 480
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "30%",
      backgroundColor: "rgba(229, 231, 235, 1)",
      fontSize: "0.875rem"
    }
  }, listUploads.map(function (item, i) {
    return /*#__PURE__*/React.createElement(_Box2["default"], {
      key: i,
      style: {
        display: "flex",
        alignItems: "center",
        paddingTop: "0.75rem",
        paddingBottom: "0.75rem",
        paddingLeft: "1rem",
        color: tab === item.name ? "#2D7FF9" : "unset",
        cursor: "pointer",
        position: "relative"
      },
      onClick: function onClick() {
        setViewSelect(true);
        setTab(item.name);
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, item.icon), /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: "0.5rem"
      }
    }, item.name), /*#__PURE__*/React.createElement("div", {
      style: {
        display: selectedFiles.filter(function (val) {
          return val.from == item.name;
        }).length == 0 ? "none" : "block",
        position: "absolute",
        top: 5,
        left: 5,
        backgroundColor: "#2D7FF9",
        color: "white",
        fontSize: "0.6rem",
        paddingLeft: "0.25rem",
        paddingRight: "0.25rem",
        borderRadius: "9999px"
      }
    }, selectedFiles.filter(function (val) {
      return val.from == item.name;
    }).length));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "70%",
      height: "auto",
      padding: "1rem"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      position: "relative"
    }
  }, !viewSelect && selectedFiles.length ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      display: "flex",
      justifyContent: "center"
    }
  }, "Selected Files"), /*#__PURE__*/React.createElement(_InputBase2["default"], {
    value: findFile,
    onChange: function onChange(e) {
      return setFindFile(e.target.value);
    },
    placeholder: "Filter",
    style: {
      borderBottom: "2px solid rgba(0,0,0,0.05)",
      paddingBottom: "0.25rem",
      fontSize: "0.875rem"
    },
    startAdornment: /*#__PURE__*/React.createElement(_InputAdornment2["default"], {
      position: "start"
    }, /*#__PURE__*/React.createElement(_Search2["default"], {
      style: {
        fontSize: "1rem"
      }
    }))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: "1rem",
      height: "90%",
      overflowY: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 500,
      display: filterFiles.length ? "block" : "none"
    }
  }, "IMAGES"), filterFiles.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        display: "flex",
        marginTop: "0.5rem"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: 50,
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.url,
      style: {
        maxWidth: 50,
        maxHeight: "100%",
        objectFit: "cover"
      },
      alt: item.fileName
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        marginLeft: "0.5rem",
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "0.875rem"
      }
    }, item.fileName), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: "0.875rem",
        display: item.size ? "block" : "none"
      }
    }, item.size < Math.pow(1024, 2) ? parseInt(item.size / 1024) : parseInt(item.size / Math.pow(1024, 2)), " ", item.size < Math.pow(1024, 2) ? "KB" : "MB"))), /*#__PURE__*/React.createElement(_Box2["default"], {
      style: {
        marginLeft: "auto",
        cursor: "pointer",
        display: "flex",
        alignItems: "center"
      },
      onClick: function onClick() {
        setSelectedFiles(selectedFiles.filter(function (val, index) {
          return index !== i;
        }));
      }
    }, /*#__PURE__*/React.createElement(_Close2["default"], {
      fontSize: "small"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      borderTop: "2px solid rgba(209, 213, 219, 1)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      marginTop: "0.5rem",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(_Button["default"], {
    onClick: function onClick() {
      return setSelectedFiles([]);
    }
  }, "Deselect All"), /*#__PURE__*/React.createElement(_Box2["default"], {
    display: "flex"
  }, /*#__PURE__*/React.createElement(_Button["default"], {
    onClick: function onClick() {
      return setViewSelect(true);
    }
  }, "Upload more"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: "0.75rem"
    }
  }, /*#__PURE__*/React.createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    onClick: function onClick(e) {
      e.preventDefault();
      onUpload(selectedFiles || []);
    }
  }, "Upload")))))) : tab === "Link (URL)" ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 40,
      display: "flex",
      width: "75%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "88%"
    }
  }, /*#__PURE__*/React.createElement(_InputBase2["default"], {
    value: url,
    onChange: function onChange(e) {
      return setUrl(e.target.value);
    },
    placeholder: "Enter a URL",
    fullWidth: true,
    style: {
      borderWidth: "1px 0 1px 1px",
      borderStyle: "solid",
      borderColor: "rgba(209, 213, 219, 1)",
      height: "100%",
      borderTopLeftRadius: "0.25rem",
      borderBottomLeftRadius: "0.25rem",
      paddingLeft: "0.5rem",
      paddingRight: "0.25rem"
    }
  })), /*#__PURE__*/React.createElement(_Box2["default"], {
    style: {
      width: "12%",
      backgroundColor: "#2D7FF9",
      padding: "0.5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderTopRightRadius: "0.25rem",
      borderBottomRightRadius: "0.25rem",
      cursor: "pointer"
    },
    onClick: function onClick() {
      if (url) {
        var urlSplit = url.split("/");
        var fileName = urlSplit[urlSplit.length - 1];
        setSelectedFiles([].concat(_toConsumableArray(selectedFiles), [{
          url: url,
          fileName: fileName,
          from: tab
        }]));
        setUrl("");
        setViewSelect(false);
      }
    }
  }, /*#__PURE__*/React.createElement(_Link2["default"], {
    style: {
      color: "white"
    }
  })))) : /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: "image/*",
    id: "uploadFile",
    name: "uploadFile",
    style: {
      display: "none"
    },
    onChange: handleChangeFile
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "uploadFile",
    style: {
      height: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      border: "2px dashed rgba(209, 213, 219, 1)",
      borderRadius: "0.5rem",
      height: "100%",
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement(_NoteAddRounded2["default"], {
    style: {
      fontSize: "5rem",
      color: "#2D7FF9"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "1.25rem",
      fontWeight: 500
    }
  }, "Select Files to Upload"))))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      bottom: -4,
      paddingBottom: 4,
      width: "100%",
      backgroundColor: "white",
      borderTop: "2px solid rgba(209, 213, 219, 1)",
      display: selectedFiles.length && viewSelect ? "block" : "none"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      marginTop: "0.75rem",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      fontWeight: 500,
      fontSize: "0.8rem"
    }
  }, "Selected Files: ", selectedFiles.length), /*#__PURE__*/React.createElement(_Button["default"], {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return setViewSelect(false);
    }
  }, "View Selected")))))));
};

DialogAttachment.propTypes = {
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  onUpload: _propTypes["default"].func
};
var _default = DialogAttachment;
exports["default"] = _default;